// Define regex patterns

export const namePattern = /^[a-zA-Z\-.' ]*$/;
export const namePatternPvq = /^([a-zA-Z.' ]+-?)*$/;
export const suffixPattern = /^[a-zA-Z\-.' ,0-9]*$/;
export const lettersAndNumbersPattern = /^[A-Za-z0-9]*$/;
export const lettersAndNumbersPatternExceptOnlyZero = /^(?!0$)[A-Za-z0-9]*$/;
export const lettersOnlyPattern = /^[A-Za-z]*$/;
export const zipCodePattern = /^\d{5}(?:[-\s]{1}\d{4})?$/;
export const notPOBoxPattern = /^((?!PO Box|P.O. Box|Post Office Box).)*$/i;
export const passportPattern = /^[a-zA-Z0-9]*$/;
export const selectiveServicePattern = /^[0-9-]*$/;
export const servicePattern = /^[A-Za-z0-9-]*$/;
export const numbersOnlyPattern = /[^0-9]/g;
export const accountNumberPattern = /^[A-Za-z0-9.\- ,]*$/;
export const ascii = /[^\x00-\x7F]/g;
export const globalFilter = /[&]/g;
export const installationNamePattern = /^[0-9A-Za-z.,()!'\- ]*$/;
export const cityPattern = /^[0-9A-Za-z.,()!'\- ]*$/;
export const firstSSNPattern = /^(?!000|666)[0-8]\d{2}$/;
export const middleSSNPattern = /^\d{2}$/;
export const lastSSNPattern = /^\d{4}$/;
